<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mb-2">EFT Details</h1>
                <p>Use this page to keep your eft details up-to-date.</p>
                <p>By completing this section, you are agreeing to receive payments under the PAYG Declaration. These payments are not subject to withholding tax.</p>
                <p>Remittance of payment will be recorded on your dashboard under RECEIPTS</p>
                <!-- <p class="font-italic">All fields marked * are mandatory.</p> -->

                <v-card class="elevation-12">
                    <v-card-text>
                        <v-form class="overwrite-inputs" ref="updateform" v-model.trim="valid" lazy-validation>
                            <v-container grid-list-lg>
                                <v-layout row wrap class="pa-0">
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field
                                            prepend-icon="person"
                                            label="Account Name"
                                            v-model.trim="account_name"
                                            :rules="[rules.required]"
                                            :error="userErrors.has('account_name')"
                                            :error-messages="userErrors.get('account_name')"
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field
                                            prepend-icon="account_balance"
                                            label="BSB Number"
                                            v-model.trim="account_bsb"
                                            :rules="[rules.required, rules.bsb]"
                                            :error="userErrors.has('account_bsb')"
                                            :error-messages="userErrors.get('account_bsb')"
                                            v-mask="'##########'"
                                            required
                                            maxlength="6"
                                            hint="should be 6 digits, no space, no dash"
                                            persistent-hint
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field
                                            prepend-icon="account_balance_wallet"
                                            label="Account Number"
                                            v-model.trim="account_number"
                                            :rules="[rules.required, rules.account]"
                                            :error="userErrors.has('account_number')"
                                            :error-messages="userErrors.get('account_number')"
                                            v-mask="'##########'"
                                            required
                                            maxlength="10"
                                            hint="should be between 6 and 10 digits"
                                            persistent-hint
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                        <v-alert class="mt-6" v-model.trim="alert" outlined transition="scale-transition" dismissible type="error">Error! Please check the form above for errors</v-alert>
                    </v-card-text>
                    <v-divider light></v-divider>
                    <v-card-actions class="py-4 justify-end">
                        <v-btn text @click="cancel" :disabled="userLoading" color="error">cancel</v-btn>
                        <v-btn :loading="userLoading" :disabled="!valid" color="primary" @click="update">update<v-icon right>edit</v-icon></v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "@store";
import moment from "moment";

export default {
    name: "eft",
    data() {
        return {
            rules: {
                required: v => !!v || "This field is required",
                bsb: v => {
                    if (v) {
                        return /^\d{6}$/.test(v) || "Please enter a valid BSB";
                    }

                    return true;
                },
                account: v => {
                    if (v) {
                        return /^(\d{6})(\d{4})?/.test(v) || "Please enter a valid account";
                    }

                    return true;
                },
            },
            account_name: "",
            account_bsb: "",
            account_number: "",
            valid: true,
            alert: false,
        };
    },
    computed: {
        userErrors() {
            return this.$store.getters["user/userErrors"];
        },
        userLoading() {
            return this.$store.getters["user/userStatus"] == "loading";
        }
    },
    methods: {
        needRequiredFields() {
            if (
                !(
                    this.account_name &&
                    this.account_bsb &&
                    this.account_number
                )
            ) {
                this.$refs.updateform.validate();
            }
        },
        cancel() {
            this.$router.push({ name: "dashboard" });
        },
        update() {
            if (this.$refs.updateform.validate()) {
                this.valid = false;

                const {
                    account_name,
                    account_bsb,
                    account_number
                } = this;

                this.$store
                    .dispatch("user/userEftUpdate", {
                        account_name,
                        account_bsb,
                        account_number
                    })
                    .then(() => {
                        this.$router.push({ name: "dashboard" });
                    })
                    .catch(err => {
                        this.valid = true;
                        this.alert = true;
                        // console.log(err);
                    });
            } else {
                this.valid = true;
                this.alert = true;
            }
        },
    },
    mounted() {
        // this.needRequiredFields();
        const profile = this.$store.getters["user/getProfile"];

        this.account_name = profile.acct_name;
        this.account_bsb = profile.acct_bsb;
        this.account_number = profile.acct_number;
    },
    created() {
        //code
    },
};
</script>

<style lang="scss" scoped>
[v-cloak] {
    display: none;
}
[v-cloak] > * {
    display: none;
}

.v-alert .v-alert__icon.v-icon {
    align-self: flex-start;
}
</style>
